import { render, staticRenderFns } from "./process-config-common.vue?vue&type=template&id=6f060b94"
import script from "./process-config-common.vue?vue&type=script&lang=ts"
export * from "./process-config-common.vue?vue&type=script&lang=ts"
import style0 from "./process-config-common.vue?vue&type=style&index=0&id=6f060b94&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports